<script>
  import Edit from "../Vectors/Edit.svelte";
  import Delete from "../Vectors/Delete.svelte";
  import Burger from "../Vectors/Burger.svelte";
  import Plus from "../Vectors/Plus.svelte";
  import EditCountryVersionVar from "../admin/EditCountryVersionVar.svelte";
  import VarSelector from "../SharedComponents/VarSelector.svelte";
  import { createEventDispatcher } from "svelte";
  import { getContext } from "svelte";
  import SortableList from "../SharedComponents/Sortable.svelte";
  import { countryStore } from "../store/Countries.js";
  const { open } = getContext("modal");
  const { snackbar } = getContext("app");

  const dispatch = createEventDispatcher();

  export let VariableList;
  export let sectionSubId;

  $: currentCountryVersion = $countryStore.currentCountryVersion;
  function stopIfPublished() {
    if (currentCountryVersion.isPublished) {
      snackbar("error", "published versions cannot be editted");
      return true;
    }
  }
  function addVariable() {
    if (stopIfPublished()) return;

    open(VarSelector, { setVar: setVar, VariableList });
  }

  function editVariable(thevar) {
    var foundVar = $countryStore.currentCountryVersion.variables.find(
      (cvv) => cvv.id == thevar.countryVersionVariableId
    );
    foundVar.countryVersionId = parseInt(
      $countryStore.currentCountryVersion.id
    );
    open(EditCountryVersionVar, { countryVersionVar: foundVar });
  }

  function replaceVar(theVar) {}

  function setVar(theVar) {
    if (stopIfPublished()) return;

    if (!VariableList) VariableList = new Array();
    var realVar = VariableList.filter(
      (v) => theVar.id != undefined && v.id == theVar.id
    );
    if (realVar.length > 0) {
      realVar[0] = theVar;
      realVar[0].variableType = theVar.variableType;
      VariableList = VariableList;
    } else {
      var maxSortOrder = getMaxSortOrder(VariableList) || 0;
      VariableList = [
        ...VariableList,
        {
          ...theVar,
          sortOrder: maxSortOrder + 1,
          sectionSubId: sectionSubId,
          countryVersionVariableId: theVar.id,
          id: 0,
        },
      ];
    }
    dispatch("ListChanged");
  }

  function getMaxSortOrder(items) {
    if (!items || items.length == 0) return 0;
    return Math.max.apply(
      Math,
      VariableList.map(function (o) {
        return o.sortOrder;
      })
    );
  }
  function sortListVariables(ev) {
    window.lastVarSortTime = Date.now();
    VariableList = ev.detail;
    dispatch("ListChanged");
  }
  function deleteVariable(variable) {
    if (stopIfPublished()) return;

    VariableList = VariableList.filter((v) => v != variable);
    dispatch("ListChanged");
  }
</script>

<h4 class="d-flex justify-content-between align-items-center mb-3">
  <span class="text-muted">Variables</span>
  <Plus on:click={addVariable} />
</h4>
<ul class="list-group mb-3">
  {#if VariableList}
    <SortableList list={VariableList} on:sort={sortListVariables} let:item>
      <li class="list-group-item d-flex justify-content-between lh-condensed">
        <div>
          <h6 class="my-0">{item.varNameKey}</h6>
        </div>
        <span class="icons">
          <Edit on:click={editVariable(item)} />
          <Delete
            on:click={deleteVariable(item)}
            disabled={stopIfPublished()}
          />
          <span title="drag to sort" draggable={!stopIfPublished()}>
            <Burger />
          </span>
        </span>
      </li>
    </SortableList>
  {/if}
</ul>
